export const defaultItem = {
  partNumber: null,
  quantity: null,
  packageQty: null,
  weight: null,
  sosCode: null,
  replacementMessage: null,
  partLevelFlags: null,
  price: {
    unitPrice: null,
    totalPrice: null,
    discountAmount: null,
    discountedPrice: null,
    coreCharges: null
  },
  availability: null
};
